(function () {
  'use strict';

  // creating this to separate the validation method from other methods in payment
  function paymentFormValidationFactory () {
    const factory = {};
    const commonFields = {
      street: ['Length'],
      zipcode: ['Length'],
      city: ['Length']
    };


    function checkLength (model, key) {
      let valid = true;
      const modelLengths = {
        name: 35,
        street: 35,
        zipcode: 5,
        city: 35,
        organizationNumber: 35
      };

      if (model && model.length) {
        valid = model.length <= modelLengths[key];
      }

      return valid;
    }

    function checkPattern (model, key) {
      const patterns = {
        organizationNumber: /^[\d]+-?[\d]+$/
      };

      return !model || model === '' ? true : patterns[key].test(model);
    }

    function checkModel (model, criterias, key, companyInfoValidity) {
      const checkMethod = {
        Length: checkLength,
        Pattern: checkPattern
      };

      criterias.forEach(function (item) {
        companyInfoValidity[key + item] = checkMethod[item](model, key);
      });

      return companyInfoValidity;
    }

    function checkCommonFieldsValidity (companyFieldsValidity, addressInfo) {
      Object.keys(commonFields).forEach(function (key) {
        companyFieldsValidity = checkModel(addressInfo[key], commonFields[key], key, companyFieldsValidity);
      });

      return companyFieldsValidity;
    }

    factory.checkModel = checkModel;
    factory.checkLength = checkLength;
    factory.checkCommonFieldsValidity = checkCommonFieldsValidity;
    factory.checkPattern = checkPattern;

    return factory;
  }

  angular.module('web2print.payment')
    .factory('paymentFormValidationFactory', paymentFormValidationFactory);
})();
